import { Type, Sticker, Palette, Layers, Image, LayoutTemplate } from 'lucide-react';
import { cn } from '@/lib/utils';

const TOOLS = [
  { key: 'template',   icon: LayoutTemplate, label: 'Meme' },
  { key: 'text',       icon: Type,    label: 'Text' },
  { key: 'sticker',    icon: Sticker, label: 'Sticker' },
  { key: 'background', icon: Palette, label: 'BG' },
  { key: 'image',      icon: Image,   label: 'Image' },
  { key: 'layers',     icon: Layers,  label: 'Layers' },
];

/**
 * Bottom toolbar for the canvas editor.
 * Horizontal icon-only strip — minimal, tap-friendly.
 */
export const Toolbar = ({ activeTool, onToolSelect, isDark }) => {
  const bgClass = isDark
    ? 'border-white/5'
    : 'bg-white border-gray-200';

  return (
    <div
      className={cn("flex items-center justify-around border-t px-1 py-1.5", bgClass)}
      style={isDark ? { background: 'var(--deep, #090B10)' } : undefined}
    >
      {TOOLS.map(({ key, icon: Icon, label }) => (
        <button
          key={key}
          onClick={() => onToolSelect(activeTool === key ? null : key)}
          className={cn(
            "flex flex-col items-center justify-center gap-0.5 w-12 h-12 rounded-lg transition-colors",
            activeTool === key
              ? isDark ? 'text-[#F07B1D]' : 'bg-gray-100 text-gray-900'
              : isDark ? 'text-white/35 hover:text-white/70' : 'text-gray-400 hover:text-gray-700 hover:bg-gray-50'
          )}
          style={isDark && activeTool === key ? { background: 'var(--fire-glow, rgba(240,123,29,0.07))' } : undefined}
          title={label}
        >
          <Icon className="h-5 w-5" strokeWidth={1.5} />
          <span className="text-[8px] tracking-wider uppercase font-mono opacity-70">{label}</span>
        </button>
      ))}
    </div>
  );
};
